import "core-js/modules/es.error.cause.js";
import passwordInput from "@/components/Common/passwordInput.vue";
import { initPassword } from "@/service/user.js";
import { encrypt } from "@/libs/rsa.js";
export default {
  data() {
    return {
      visible: false,
      form: {
        newPase: "",
        surePsd: ""
      },
      callback: null,
      rules: {
        surePsd: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error($t("hrcq067", "请输入确认密码")));
            } else if (value !== this.form.newPase) {
              callback(new Error($t("vr84smb", "密码不一致，请重新输入")));
            } else {
              callback();
            }
          }
        }]
      },
      InputTypeMap: {
        true: {
          type: "text",
          icon: "ios-eye-outline"
        },
        false: {
          type: "password",
          icon: "ios-eye-off-outline"
        }
      },
      tipText: {
        title: $t("553si95", "请立即设置"),
        tip: "",
        confirmBtn: $t("fugigo4", "立即设置"),
        cancelBtn: $t("fr6dw14", "稍后设置")
      },
      showPassword: false
    };
  },
  components: {
    passwordInput
  },
  computed: {
    inputType() {
      return this.InputTypeMap[this.showPassword];
    }
  },
  methods: {
    changeEye() {
      this.showPassword = !this.showPassword;
    },
    open(callback, config) {
      // 每次打开都重置表单，避免上一次未提交的密码残留。
      this.form = {
        newPase: "",
        surePsd: ""
      };
      // 弹窗复用时同步清理 View Design 与自定义密码组件的校验状态。
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields();
        }
        if (this.$refs.formPsd) {
          this.$refs.formPsd.resetFields();
        }
      });
      this.callback = callback;
      config && (this.tipText = config);
      this.visible = true;
    },
    cancel() {
      this.visible = false;
      this.callback && this.callback();
    },
    submit() {
      this.$refs.form.validate(async valid => {
        let valid2 = await this.$refs.formPsd.validate();
        if (valid && valid2) {
          const {
            data: {
              result
            }
          } = await initPassword({
            password: await encrypt(this.form.newPase)
          });
          if (result == 0) {
            // 初始密码设置成功时使用设置语义，避免和修改密码提示混淆。
            this.$Message.success({
              content: $t("i5nn5r4", "设置成功")
            });
            localStorage.removeItem("shouldInitPassword");
            // 密码初始化完成后同步用户状态，确保个人菜单立即从“设置密码”切换为“修改密码”。
            this.$store.commit("setUserInfo", {
              shouldInitPassword: "F"
            });
          }
          this.visible = false;
        }
      });
    }
  }
};